export default __webpack_public_path__ + "static/media/DSC02660.e25fb5fa.jpg";